module.exports = __webpack_public_path__ + "media/images/award-badges-mobile-zh-my-fd9608aa775a43f6c3b1c295cc7e04fe.svg";